/* eslint-disable */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ModalContext } from 'App';
import SideScrollingTab from 'modules/common/components/SideScrollingTab';
import { convertToTitleCase } from '../../../../helper';
import * as action from '../action';
import * as c from '../constant';
import VerifyReceipt from '../components/VerifyReceipt';
import CmsContext from '../../../../context/CmsContext';
import ViewSOA from '../components/ViewSOA';
import ViewOR from '../components/ViewOR';

function ApplicationContentSmartCity({
  // transactionInfo,
  transactionInfoListSmartCity,
  // showTransaction,
  showTransactionListSmartCity,
  clearTransaction,
  isLoading,
  match,
  taxpayer,
  taxpayerProfile,
  realProperties,
}) {
  const setModal = useContext(ModalContext);
  const cmsContext = useContext(CmsContext);
  // const selectedTransaction = match.params.id;
  const selectedTransaction = match.params.id;

  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');
  const permissions = getJson('permissions');

  const updateData = () => {
    // showTransaction(selectedTransaction);
    showTransactionListSmartCity(selectedTransaction?.replace('_', '/')); // add payload id from this transactionInfo)
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const formatPeriodManila = (data) => {
    return data
      ? data
          .replace('-1', ' - 1st quarter')
          .replace('-2', ' - 2nd quarter')
          .replace('-3', ' - 3rd quarter')
          .replace('-4', ' - 4th quarter')
      : '---';
  };

  const formatPeriod = (data) => {
    return data
      ? data
          .toString()
          .replace('1', '1st quarter')
          .replace('2', '2nd quarter')
          .replace('3', '3rd quarter')
          .replace('4', '4th quarter')
      : '---';
  };

  const showVerifyReceipt = (status) => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'FOR PICK-UP',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ]?.includes(status);
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfoListSmartCity}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const onViewSOA = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <ViewSOA data={transactionInfoListSmartCity} id={selectedTransaction} />
      ),
      title: `View Statement of Account`,
      modalSize: 'modal-xl',
    });
  };

  const onViewOR = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOR data={transactionInfoListSmartCity} />,
      title: `View Original Receipt`,
      modalSize: 'modal-xl',
    });
  };

  const paymentStatusBadge = (status) => {
    if (status === 'PENDING')
      return (
        <span className="bg-warning px-2 rounded text-light">
          {convertToTitleCase(status)}
        </span>
      );
    if (status === 'PAID')
      return (
        <span className="bg-success px-2 rounded text-light">
          {convertToTitleCase(status)}
        </span>
      );
    if (status?.includes('QUARTER'))
      return (
        <span className="bg-success px-2 rounded text-light">
          {convertToTitleCase(status)}
        </span>
      );

    return '---';
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-between">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(`${_.get(taxpayer, 'account_name')}`)
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'account_name') || '-'}`}
                      </h1>
                    </div>
                  </div>
                  <div className="d-flex justify-content-end mb-3">
                    {_.get(
                      transactionInfoListSmartCity,
                      'included.module.attributes.or_generated_at'
                    ) &&
                      Acl(permissions, ['RPTAX VIEW E-OR']) && (
                        <button
                          onClick={onViewOR}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mr-2"
                          type="button"
                        >
                          View OR
                        </button>
                      )}
                    {_.get(
                      transactionInfoListSmartCity,
                      'included.module.attributes.soa_generated_at'
                    ) &&
                      !_.get(
                        transactionInfoListSmartCity,
                        'included.module.attributes.or_generated_at'
                      ) &&
                      Acl(permissions, ['RPTAX VIEW E-SOA']) && (
                        <button
                          onClick={onViewSOA}
                          className="btn btn-primary cms-bg-color-primary font-weight-bold mr-2"
                          type="button"
                        >
                          View SOA
                        </button>
                      )}
                    {showVerifyReceipt(
                      _.get(
                        transactionInfoListSmartCity,
                        'attributes.transaction_status'
                      )
                    ) && (
                      <button
                        onClick={handleVerifyReceipt}
                        className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                        type="button"
                      >
                        Assess Payment Receipt
                      </button>
                    )}
                  </div>
                  <Tabs>
                    <SideScrollingTab dragToScroll>
                      <TabList>
                        {/* <Tab>Transaction</Tab> */}
                        <Tab>Account Details</Tab>

                        {/* for PLDT Smart City | Add CMS Later SMART_CITY_RPTAX_SETTINGS or SMART_CITY_ENABLED */}
                        <Tab>RPTAX (Current)</Tab>
                        <Tab>RPTAX (Delinquent)</Tab>
                      </TabList>
                    </SideScrollingTab>

                    {/* <TabPanel>
                      <TransactionInformation
                        module="rpts"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel> */}
                    <TabPanel
                      className=""
                      style={{ overflowY: 'scroll', maxHeight: '520px' }}
                    >
                      {/* Note: move to a separate component */}
                      {/*  account details */}
                      <div className="col-12 p-3">
                        {_.get(transactionInfoListSmartCity, 'included')
                          ?.filter((info) => info?.type === 'taxpayers')
                          ?.map((data, i) => {
                            const taxpayer = data.attributes;

                            return (
                              <table key={i} className="transaction-table table table-borderless table-sm table-striped table-hover">
                                <tbody>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Tax Declaration Number (TDN)
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {(
                                          _.get(taxpayer, 'tdn') || '--'
                                        ).toUpperCase()}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Property Identification Number (PIN)
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(
                                          taxpayer,
                                          'pin',
                                          '--'
                                        )?.toUpperCase()}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Account Number / Owner ID
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'acount_number', '--')}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Owners Full Name
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'display_name', '--')}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Company / Corporation / Building Number
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'corporation')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Period Covered From
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'period_from')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Period Covered To
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'period_to')}</b>
                                    </td>
                                  </tr>

                                  <p className="cms-text-primary font-weight-bold pt-3 pb-1">
                                    Location
                                  </p>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Region
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'region_name', '--')}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Province
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'province_name', '--')}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Barangay
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'barangay_name', '--')}
                                      </b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Street
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'street', '--')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Zip Code
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'zip_code', '--')}</b>
                                    </td>
                                  </tr>

                                  <tr>
                                    <td className="text-dark" width="250">
                                      Area
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'area')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      OCT/ TCT/ CLOA No.
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'area')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Block Number
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'block_no')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Kind of Property
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'business_type')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Classification
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'classification')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      Special Classes
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>
                                        {_.get(taxpayer, 'special_classes')}
                                      </b>
                                    </td>
                                  </tr>

                                  <h3 className="cms-text-primary font-weight-bold pt-3 pb-1">
                                    Boundaries
                                  </h3>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      North
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'north')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      South
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'south')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      East
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'east')}</b>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td className="text-dark" width="250">
                                      West
                                    </td>
                                    <td className="text-dark" width="1">
                                      :
                                    </td>
                                    <td>
                                      <b>{_.get(taxpayer, 'west')}</b>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            );
                          })}
                      </div>
                    </TabPanel>
                    {/* for PLDT Smart City | Add CMS Later SMART_CITY_RPTAX_SETTINGS or SMART_CITY_ENABLED */}
                    <TabPanel
                      className=""
                      style={{ overflowY: 'scroll', maxHeight: '520px' }}
                    >
                      {/*  todo: move this to another component */}
                      {_.get(transactionInfoListSmartCity, 'data')
                        ?.filter(
                          (dataInfo) =>
                            _.get(dataInfo, 'attributes.is_delinquent') === 0
                        )
                        ?.map((dataInfo) => {
                          return _.get(transactionInfoListSmartCity, 'included')
                            ?.filter(
                              (info) =>
                                info?.type === 'transaction_histories' &&
                                dataInfo.id === info.id
                            )
                            ?.map((item) => {
                              const transaction = _.get(item, 'attributes');

                              return (
                                <>
                                  <div className="p-3">
                                    {/* PRINT BUTTON */}
                                    <div className="w-100 d-flex align-items-center justify-content-end">
                                      <button
                                        type="button"
                                        className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                                        onClick={() => {}}
                                      >
                                        <i className="fas fa-print mr-2" />
                                        Print SOA/Tax Declaration
                                      </button>
                                    </div>
                                    {/* TDN/PIN */}
                                    <div className="container-fluid mt-2">
                                      <div className="row">
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              TDN:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.tdn',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-2">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              PIN:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.pin',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>

                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Year:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.year',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Period:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.period',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <hr className="px-" />
                                    {/* Other Info */}
                                    <div className="container-fluid mt-2">
                                      <div className="row">
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Valid ID to Present:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'valid_id_to_present',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-2">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Permit Type:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'permit_type',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>

                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Payment Status:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {paymentStatusBadge(
                                                _.get(
                                                  transaction,
                                                  'status',
                                                  '--'
                                                )
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Print Status:
                                            </label>
                                            <span className="cit-span">:</span>
                                            {/* todo: add background color and replace api key */}
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'printed_at',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Transmittal&nbsp;No:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'bpls_transmittal_no',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Transaction ID:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(transaction, 'id', '--')}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Reference No. Generated At:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'soa_generated_at',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Reference Number:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'refno',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Posted:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'paid_at',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Payment Amount:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'amount',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-6 mt-1">
                                      <div className="cit-inner">
                                        <label className="font-weight-bold mb-0 mr-2 cit-label">
                                          Remarks
                                        </label>
                                        <span className="cit-span">:</span>
                                        <span className="transaction-text p-0">
                                          <pre>
                                            {!_.isNil(
                                              _.get(
                                                transaction,
                                                'remarks',
                                                '--'
                                              )
                                            )
                                              ? _.get(
                                                  transaction,
                                                  'remarks',
                                                  '--'
                                                )
                                              : '--'}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            });
                        })}
                    </TabPanel>
                    <TabPanel
                      className=""
                      style={{ overflowY: 'scroll', maxHeight: '520px' }}
                    >
                      {/* Delinquent  todo: move this to another component */}
                      {_.get(transactionInfoListSmartCity, 'data')?.filter(
                        (dataInfo) =>
                          _.get(dataInfo, 'attributes.is_delinquent') === 1
                      )?.length === 0 && (
                        <div className="p-3">
                          <div className="alert alert-info p-2">
                            No availabel delinquent transaction.
                          </div>
                        </div>
                      )}
                      {_.get(transactionInfoListSmartCity, 'data')
                        ?.filter(
                          (dataInfo) =>
                            _.get(dataInfo, 'attributes.is_delinquent') === 1
                        )
                        ?.map((dataInfo) => {
                          return _.get(transactionInfoListSmartCity, 'included')
                            ?.filter(
                              (info) => info?.type === 'transaction_histories'
                            )
                            ?.map((item) => {
                              const transaction = _.get(item, 'attributes');
                              return (
                                <>
                                  <div className="p-3">
                                    {/* PRINT BUTTON */}
                                    <div className="w-100 d-flex align-items-center justify-content-end">
                                      <button
                                        type="button"
                                        className="btn btn-primary cms-bg-color-primary cms-outline-primary"
                                        onClick={() => {}}
                                      >
                                        <i className="fas fa-print mr-2" />
                                        Print SOA/Tax Declaration
                                      </button>
                                    </div>
                                    {/* TDN/PIN */}
                                    <div className="container-fluid mt-2">
                                      <div className="row">
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              TDN:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.tdn',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-2">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              PIN:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.pin',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>

                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Year:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.year',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Period:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                dataInfo,
                                                'attributes.period',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <hr className="px-" />
                                    {/* Other Info */}
                                    <div className="container-fluid mt-2">
                                      <div className="row">
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Valid ID to Present:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'valid_id_to_present',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-2">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Permit Type:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'permit_type',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>

                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Payment Status:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {paymentStatusBadge(
                                                _.get(
                                                  transaction,
                                                  'status',
                                                  '--'
                                                )
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Print Status:
                                            </label>
                                            <span className="cit-span">:</span>
                                            {/* todo: add background color and replace api key */}
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'printed_at',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Transmittal&nbsp;No:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'bpls_transmittal_no',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Transaction ID:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(transaction, 'id', '--')}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Reference No. Generated At:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'soa_generated_at',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Reference Number:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'refno',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Posted:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'paid_at',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-12 col-lg-6 mt-1">
                                          <div className="cit-inner">
                                            <label className="font-weight-bold mb-0 mr-2 cit-label font-weight-bold">
                                              Payment Amount:
                                            </label>
                                            <span className="cit-span">:</span>
                                            <span className="transaction-text p-0">
                                              {_.get(
                                                transaction,
                                                'amount',
                                                '--'
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-6 mt-1">
                                      <div className="cit-inner">
                                        <label className="font-weight-bold mb-0 mr-2 cit-label">
                                          Remarks
                                        </label>
                                        <span className="cit-span">:</span>
                                        <span className="transaction-text p-0">
                                          <pre>
                                            {!_.isNil(
                                              _.get(
                                                transaction,
                                                'remarks',
                                                '--'
                                              )
                                            )
                                              ? _.get(
                                                  transaction,
                                                  'remarks',
                                                  '--'
                                                )
                                              : '--'}
                                          </pre>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              );
                            });
                        })}
                    </TabPanel>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

ApplicationContentSmartCity.defaultProps = {
  id: '',
};

ApplicationContentSmartCity.propTypes = {
  // selectedTransaction: PropTypes.string.isRequired,
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  // showTransaction: PropTypes.instanceOf(Function).isRequired,
  showTransactionListSmartCity: PropTypes.instanceOf(Function).isRequired,
  // approveTransaction: PropTypes.instanceOf(Function).isRequired,
  // transactionInfo: PropTypes.instanceOf(Object).isRequired,
  transactionInfoListSmartCity: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  realProperties: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  // transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  transactionInfoListSmartCity:
    _.get(api, `${c.SHOW_TRANSACTION_SMART_CITY}.res`) || [],
  taxpayerProfile:
    _.get(
      api,
      `${c.SHOW_TRANSACTION_SMART_CITY}.item.included.taxPayer.attributes`
    ) || {},
  taxpayer:
    {
      ...(_.get(
        api,
        `${c.SHOW_TRANSACTION_SMART_CITY}.item.included.module.attributes`
      ) || {}),
      business_establishments:
        _.get(
          api,
          `${c.SHOW_TRANSACTION_SMART_CITY}.item.included.businessEstablishments`
        ) || [],
    } || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION_SMART_CITY) > -1,
  realProperties:
    _.get(
      api,
      `${c.SHOW_TRANSACTION_SMART_CITY}.item.included.realProperties`
    ) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(ApplicationContentSmartCity);
